import { RefObject, useRef } from 'react'

import useIsFloaterInWrapperView from '../../hooks/useIsFloaterInWrapperView'

import { joinClassNames } from '../../utils/styles'
import styles from './bulb.module.scss'

interface IBulbTooltipProps {
    errorMessage: string
    scrollWrapperRef: RefObject<HTMLElement>
    iconRef: RefObject<HTMLElement>
}

function BulbTooltip(props: IBulbTooltipProps) {
    const { scrollWrapperRef, iconRef, errorMessage } = props

    const tooltipRef = useRef(null)

    const [{ isOverflowing }] = useIsFloaterInWrapperView(
        scrollWrapperRef,
        tooltipRef,
        iconRef,
        10
    )

    return (
        <span
            ref={tooltipRef}
            className={joinClassNames(
                styles.bulb__tooltip,
                isOverflowing && styles.bulb__tooltipBottom
            )}
        >
            {errorMessage}
        </span>
    )
}

export default BulbTooltip
